module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-center space-between tab-container",
    style: (("border-bottom:0.1rem solid " + (_vm.globalColors.titulo) + ";border-top:0.1rem solid " + (_vm.globalColors.titulo)))
  }, _vm._l((_vm.filters), function(item, index) {
    return _c('button', {
      key: index,
      class: [
        'flex-auto',
        'h-100',
        'bgWhite',
        'btn-item' ],
      style: (("background-color:" + (item.active ? _vm.globalColors.primary : 'white') + ";color:" + (item.active ? 'white' : _vm.globalColors.titulo))),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onClick(item)
        },
        "mouseover": function($event) {
          _vm.onMouseOver(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f59d46","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab.vue
// module id = 532
// module chunks = 1 3 6